<section
  #categorySection
  *ngIf="allCategories?.length || isLoading"
  class="category-section"
>
  <div class="container">
    <div class="heading-wrapper heading-wrapper--category">
      <div>
        <h2 class="main-heading text-capitalize">
          {{ "categories.categories" | translate }}
        </h2>
        <p class="mb-0">
          {{ "categories.catgry-desc" | translate }}
        </p>
      </div>
      <button
        *ngIf="
          isShowAllCatgrsBtn && slicedCategories.length !== allCategories.length
        "
        class="btn btn-outline-primary d-none d-sm-inline-block"
        (click)="onExploreAllCtgrs()"
      >
        {{ "buttons.explore" | translate }}
        {{ allCategories.length - initialListCount }}
        {{ "buttons.more" | translate }}
        {{ "categories.categories" | translate }}
      </button>
    </div>
    <div class="row">
      <ng-container *ngIf="isLoading; else categoryCards">
        <div
          *ngFor="let category of loadingCtgrs"
          class="col-md-4 category-col"
        >
          <app-skeleton-loader
            skeletonLoaderClass="border-gray-200 rounded"
          ></app-skeleton-loader>
        </div>
      </ng-container>

      <ng-template #categoryCards>
        <div
          #categoryCard
          *ngFor="let category of slicedCategories"
          class="col-md-4 category-col"
        >
          <div class="card card--category">
            <div class="card-front">
              <img
                width="78"
                height="78"
                loading="lazy"
                fetchpriority="low"
                class="card__img resp-image"
                imgFallback
                [src]="categoriesConfig[category.categoryId]?.image"
                [alt]="category.description"
              />
              <div class="card__body">
                <h4>{{ category.description || "N.A." }}</h4>
                <p class="card-text cat-name line-clamp-3">
                  {{ categoriesConfig[category.categoryId]?.desc | translate }}
                </p>
              </div>
            </div>

            <a
              class="card-back"
              matRipple
              role="button"
              (click)="navigateToService(category)"
            >
              <div class="card__body position-relative">
                <img
                  class="arrow-icon"
                  loading="lazy"
                  fetchpriority="low"
                  imgFallback
                  src="https://media.umangapp.in/cdn/landing/theme/icons/arrow-right.svg"
                  alt="arrow-right"
                  width="24px"
                  height="24px"
                />
                <h4>{{ category.description || "N.A." }}</h4>
                <p class="card-text cat-name cat-name--scroll">
                  {{ categoriesConfig[category.categoryId]?.desc | translate }}
                </p>
              </div>
            </a>
          </div>
        </div>
      </ng-template>
    </div>

    <div *ngIf="isShowAllCatgrsBtn" class="d-block d-sm-none text-center mt-2">
      <button class="btn btn-outline-primary" (click)="onExploreAllCtgrs()">
        {{ "buttons.explore" | translate }} {{ "buttons.more" | translate }}
      </button>
    </div>
  </div>
</section>
